/**
 * @author Arul Vivek
 */
 import service from '../Common/'
 import constants from '../../../settings/shared/constants'


 function getSchedulerTypes() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.scheduler.GetSchedulerTypes,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
}

function getAllScheduer(pageNumber,pageSize) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.scheduler.GetAllScheduler+"?page="+pageNumber+"&size="+pageSize,
            method: 'GET',
            headers: headers,
            data: '' 
        }); 
}

function cancelSchedulerById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.scheduler.cancelScheduler+id,
            method: 'GET',
            headers: headers,
            data: '' 
        }); 
}

function getSchedulerFor(type) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.scheduler.GetSchedulerFor + type,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
}

function getSchedulerByTypes(type) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.scheduler.GetSchedulerByTypes+"?scheduleType="+type,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
}

function getSchedulerbyId(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.scheduler.GetSchedulerbyId + id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
}

function updateScheduler(schedulerData,id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.scheduler.UpdateScheduler + id,
            method: 'PUT',
            headers: headers,
            data:  schedulerData
        });
}
 

//To export run function
const SchedulerService = {
    getSchedulerTypes,getSchedulerFor,getSchedulerByTypes,getSchedulerbyId,updateScheduler,getAllScheduer,
    cancelSchedulerById}

    export default SchedulerService;
